module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 83.368edf58.png";